import { createContext } from "react";

import type {
  IUpdateVulnerabilityForm,
  IVulnerabilityModalValues,
} from "../types";

const defaultValue: IUpdateVulnerabilityForm = {
  acceptanceDate: undefined,
  assigned: undefined,
  customSeverity: null,
  externalBugTrackingSystem: "",
  justification: undefined,
  tag: "",
  treatment: "",
};

const updateDescriptionContext = createContext<IVulnerabilityModalValues>([
  defaultValue,
  (): void => undefined,
]);

export { defaultValue, updateDescriptionContext };
